import * as types from '../types'

/**
 * 首页数据
 * bannerList: 首页轮播图
 * topClassify: 首页顶部分类
 * activityItems: 首页活动轮播
 * activityList: 首页活动列表
 * recommends: 当季新品
 * categoryGoodsList: 首页各个顶级分类下的推荐商品
 * @type {Object}
 */
const state = {
    bannerList: [],
    topClassify: [
        {
            id: 5,
            thumb: 'classify/classify1.jpg',
            title: '当季新品',
            url: 'events/3'
        },
        {
            id: 2,
            thumb: 'classify/classify2.jpg',
            title: '优惠推选',
            url: 'events/1'
        },
        {
            id: 3,
            thumb: 'classify/classify3.jpg',
            title: '充值专区',
            url: 'balance/1'
        },
        {
            id: 4,
            thumb: 'classify/classify4.jpg',
            title: '我的优惠券',
            url: 'my_coupon/1'
        }
    ],
    activityItems: [],
    activityList: [],
    recommends: {
        name: '当季新品',
        recommendList: []
    },
    categoryGoodsList: []
}

const getters = {

}

const actions = {
}

const mutations = {
    [types.CHANGE_BANNER] (state, focus) {
        state.bannerList = focus
    },

    [types.CHANGE_TOPIC] (state, topic) {
        state.activityItems = topic;
    },

    [types.CHANGE_RECOMMEND] (state, recommendList) {
        state.recommends.recommendList = recommendList
    },

    [types.CHANGE_INDEX_GOODS] (state, goods) {
        state.categoryGoodsList = goods
    },

    [types.CHANGE_LASTEST] (state, list) {
        let params = {
            id: 100,
            name: '最新产品',
            img: '',
            skus: []
        }
        params.skus = list
        state.activityList.push(params)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/site.js